<template>
  <confirm-dialog
    ref="dialog"
    title="Confirm Delete Tracking Record"
    :confirmCb="confirmDelete"
    :cancelCb="cancelCb"
    :width="35"
    :loading="loadingDelete"
  >
    <template v-slot:content>
      <div class="delete-wrapper f-c" v-if="record" v-loading="loadingDelete">
        <div class="f-c record-no-wrapper">
          <span class="title">Tracking Record No:</span>
          <span class="record-no">{{ recordNo }}</span>
        </div>
        <div class="f-c record-no-wrapper">
          <span class="title">Pallets</span>
          <div class="pallet-nos-list">
            <el-tag
              v-for="palletNo in palletNos"
              :key="palletNo"
              type="success"
            >
              {{ palletNo }}
            </el-tag>
          </div>
        </div>
      </div>
    </template>
  </confirm-dialog>
</template>
<script>
// others
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components

import ConfirmDialog from '@/components/common/Confirm.vue'
import { deleteShipmentTrackingRecord } from '@/api/tracking'
export default {
  name: 'TrackingDeleteDialog',
  mixins: [dialogMixin],
  components: {
    ConfirmDialog
  },
  props: {
    successCb: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loadingDelete: false,
      record: null
    }
  },
  computed: {
    recordNo() {
      return this.record.no
    },
    palletNos() {
      return this.record.palletNos
    }
  },
  methods: {
    confirmDelete(close, error) {
      this.loadingDelete = true
      deleteShipmentTrackingRecord(this.record.id).then(() => {
        this.successCb()
        close()
      }).catch(err => {
        error(err)
      }).finally(() => {
        this.loadingDelete = false
      })
    },
    open(record, cb = undefined) {
      this.$set(this, 'record', record)
      this.$refs.dialog.open()
    },
    close() {
      this.originPallet = null
      this.$refs.dialog.close()
    },
    valueChange() {},
    cancelCb() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
.delete-wrapper {
  gap: 10px;
  .title {
    font-size: 16px;
  }
  .record-no-wrapper {
    gap: 5px;
    .record-no {
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>
